// Résolution des droits effectifs côté client (miroir de backend/permissions.py)
export const ROLE_KEYS = ["admin", "agent", "coordinator", "approver", "user"];

export function effectivePermissions(user, catalog) {
    if (!user) return [];
    if (user.role === "admin") return catalog?.all_permissions || [];
    const fromRole = catalog?.role_permissions?.[user.role] || [];
    return Array.from(new Set([...fromRole, ...(user.permissions || [])]));
}

export function featureLevel(perms, feature) {
    if (perms.includes(`${feature}:manage`)) return "manage";
    if (perms.includes(`${feature}:view`)) return "view";
    return null;
}

export function canFeature(perms, feature, level = "view") {
    const current = featureLevel(perms, feature);
    if (!current) return false;
    return level === "view" ? true : current === "manage";
}

// Remplace le niveau d'une fonctionnalité dans une liste de permissions
export function withFeatureLevel(perms, feature, level) {
    const rest = perms.filter((p) => !p.startsWith(`${feature}:`));
    return level ? [...rest, `${feature}:${level}`] : rest;
}

export function groupFeatures(features = []) {
    const groups = [];
    for (const f of features) {
        let g = groups.find((x) => x.name === f.group);
        if (!g) { g = { name: f.group, features: [] }; groups.push(g); }
        g.features.push(f);
    }
    return groups;
}
